module.exports = __webpack_public_path__ + "img/floor_f3_01.91889daf.png";